export default {
    state: {
        initials: localStorage.getItem('initials') === null ? '' : localStorage.getItem('initials')
    },
    mutations: {
        setInitials(state, initials) {
            state.initials = initials;
        },
    },
    actions: {
        setInitials({commit}, initials) {
            localStorage.setItem('initials', initials)
            commit('setInitials', initials);
        },
    },
};